<template>
    <div>
        <v-overlay :value="overlay" :style="`width:${bgWidth}px;`" :dark="false" :color="overlayColor" :opacity="0.95">
            <PinDialogPage
                @cancel="onCancel"
                @submit="onSubmit"
                :class="animationClass"
            />
        </v-overlay>

        <div class="icon-label-vertical" @click="onOpen">
            <v-icon style="font-size: 50px;">mdi-lock-outline</v-icon>
            <span>{{ $t('pin') }}</span>
        </div>
    </div>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";
import PinDialogPage from "../../views/dashboard/PinDialogPage.vue";

export default {
    mixins: [layoutMixin],
    components:{
        PinDialogPage
    },
    props:{
        disabled:{
            type:Boolean,
            default:false
        },
    },
    data() {
        return {
            overlay:false,
            overlayColor:'#333',
            pin:'',
            animationClass:'',
            animationFailedDuration:1000,
            animationSuccessDuration:1500
        }
    },
    methods: {
        onOpen(){
            if (!this.disabled) {
                this.overlay=true;
            }
        },
        onCancel(){
            this.overlay=false;
        },
        onSubmit(data){
            this.showSuccessAnimation().then(()=>{
                this.overlay=false;
                this.$emit('success',data);
            });
        },
        showSuccessAnimation(){
            return new Promise((resolve)=>{
                this.animationClass='bounce';
                this.overlayColor=CONFIG.getGreen();
                setTimeout(()=>{
                    this.resetOverlayAnimation();
                    resolve();
                },this.animationSuccessDuration);
            });
        },

        resetOverlayAnimation(){
            this.animationClass='';
            this.overlayColor="#333";
        }
    },
}
</script>

<style lang="scss" scoped>
.icon-label-vertical {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.bounce {
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-name: bounce;
    animation-timing-function: ease;
}
@keyframes bounce {
    0%   { transform: translateY(0); }
    30%  { transform: translateY(-100px); }
    50%  { transform: translateY(0); }
    100% { transform: translateY(0); }
}

.shake-horizontal {
    -webkit-animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
    animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
}

@-webkit-keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
@keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
</style>

